import styled from 'styled-components';

export const colSetup = ({width}) => `
    flex: 0 0 ${width || '100%'};
    max-width: ${width || '100%'};
`;

export const ColContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: var(--row-spacer);
    padding-left: var(--row-spacer);

    ${({colsize}) => {
        if (colsize) {
            return ` ${colSetup({width: `${colsize}%`})};`;
        } else {
            return ` 
                width: unset;
            `;
        }
    }}
    ${({$emptyState}) =>
        !$emptyState
            ? ''
            : `
            opacity: 0.5;
            cursor: not-allowed;
        `}}
`;
